import { render } from "./SelecionarHora.vue?vue&type=template&id=03589dc0&ts=true"
import script from "./SelecionarHora.vue?vue&type=script&lang=ts"
export * from "./SelecionarHora.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__